module.exports = __webpack_public_path__ + "static/media/avatar_placeholder.317739de.png";